import React, { useState, useEffect } from "react";
import APIServices from "../../services/APIServices";
import appToast, { TOAST_TYPE } from "../../utils/AppToast";
import { selectLoader } from "../../utils/Helpers";

const AddEditUserPrompt = ({
  closeModal,
  promptId = "",
  setUpdatedPromptId,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    promptText: "",
    isDefault: false,
  });
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [error, setError] = useState();

  // Fetch prompt data if editing
  useEffect(() => {
    if (promptId) {
      fetchPromptDetails();
    }
  }, [promptId]);

  const fetchPromptDetails = async () => {
    setLoading(true);
    setPageLoading(true);
    try {
      const response = await APIServices.get(`/prompt/${promptId}`);
      if (response && response.prompt) {
        setFormData({
          name: response.prompt.name || "",
          promptText: response.prompt.promptText || "",
          isDefault: response.prompt.isDefault || false,
        });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setPageLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const validateForm = () => {
    const errs = {};
    if (!formData.name.trim()) errs.name = "Name is required.";
    if (!formData.promptText.trim())
      errs.promptText = "Prompt text is required.";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const endpoint = promptId ? `/prompt/${promptId}` : "/prompt";
    try {
      const response = promptId
        ? await APIServices.put(endpoint, formData)
        : await APIServices.post(endpoint, formData);

      if (response.message) {
        appToast(response.message, TOAST_TYPE.SUCCESS);
        if (setUpdatedPromptId && response.prompt?._id) {
          setUpdatedPromptId(response.prompt._id);
        }
        closeModal();
      } else {
        appToast("Something went wrong", TOAST_TYPE.ERROR);
      }
    } catch (err) {
      console.error(err);
      appToast("An error occurred", TOAST_TYPE.ERROR);
    } finally {
      setLoading(false);
    }
  };

  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {" "}
      {pageLoading ? (<div className="nodata-loader">{selectLoader(70)}</div>) :
      (
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            name="name"
            className={`form-control ${errors.name ? "form-invalid" : ""}`}
            placeholder="Prompt Name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && (
            <small className="error-message">{errors.name}</small>
          )}
        </div>

        <div className="form-group ">
          <textarea
            name="promptText"
            className={`form-control h-auto ${
              errors.promptText ? "form-invalid" : ""
            }`}
            placeholder="Enter prompt text..."
            rows={6}
            value={formData.promptText}
            onChange={handleChange}
          />
          {errors.promptText && (
            <small className="error-message">{errors.promptText}</small>
          )}
        </div>

        <div className="form-group form-control align-items-center d-flex justify-content-between">
          <label className="form-check-label text-color">Set as default</label>
          <label className="switch mb-0">
            <input
              type="checkbox"
              name="isDefault"
              checked={formData.isDefault}
              onChange={handleChange}
            />
            <span className="slider round"></span>
          </label>
        </div>

        <button className="btn-black" type="submit">
          {!loading ? (promptId ? "Save" : "Create") : selectLoader(35)}
        </button>
      </form>
      )}
    </div>
  );
};

export default AddEditUserPrompt;
